import React from 'react';
import {Row, Col} from 'react-bootstrap';

export default  function ActualTable({
  groupId, 
  timeEntriesPerBand,
  budgetScopes,
  fteDivisor 
}) {
  const renderTimeEntries = () => {
    let timeEntriesPerBandRows = [];
    let totalManHours = 0;
    let totalManDays = 0;
    let totalPercentage = 0;
    let totalFTE = 0;

    if (budgetScopes.length) {
      timeEntriesPerBand.length && timeEntriesPerBand.forEach(timeEntriesPerBandItem => {
        for (const key in timeEntriesPerBandItem) {
          if (key.includes('band')) {
            let manHours = +timeEntriesPerBandItem[key].toFixed(2);
            let manDays = +(manHours / 8).toFixed(2);
  
            totalManHours += manHours;
            totalManDays += manDays;
          }
        }
      })
  
      timeEntriesPerBand.length && timeEntriesPerBand.forEach(timeEntriesPerBandItem => {
        for (const key in timeEntriesPerBandItem) {
          if (key.includes('band')) {
            let manHours = +(timeEntriesPerBandItem[key]).toFixed(2);
            let manDays = +(manHours / 8).toFixed(2);
            let percentage = 0;
            let fte = 0;
  
            if (manHours > 0) {
              fte = manDays / fteDivisor;
              percentage = (manHours /  totalManHours) * 100;
              totalPercentage += +percentage;
              totalFTE += fte;
            }
  
            timeEntriesPerBandRows.push(
              <Row>
                <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
                  <span className={"actual-mandays-" + groupId}>
                    {manDays.toFixed(2)}
                  </span>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
                  <span className={"actual-manhours-" + groupId}>
                    {manHours.toFixed(2) }
                  </span>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
                  <span className={"actual-percentage-" + groupId}>
                    {percentage.toFixed(2)}%
                  </span>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
                  <span className={"actual-fte-" + groupId}>
                    {fte.toFixed(2) }
                  </span>  
                </Col>
              </Row>
            )
          }
        }
      })
  
      timeEntriesPerBandRows.length && timeEntriesPerBandRows.push(
        <Row>
          <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"actual-mandays-" + groupId}>
              {totalManDays.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"actual-manhours-" + groupId}>
              {totalManHours.toFixed(2)}
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"actual-percentage-" + groupId}>
              {totalPercentage.toFixed(2)}%
            </span>
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">
            <span className={"actual-fte-" + groupId}>
              {totalFTE.toFixed(2)}
            </span>
          </Col>
        </Row>
      )
    }

    return timeEntriesPerBandRows;
  }
  return (
    <>
      <Row>
      <Col xs={3} sm={3} md={3} lg={3} xl={3}></Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Mandays</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Manhours</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">Percentage</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-right">FTE</Col>
      </Row>
      {renderTimeEntries()}
    </>
  )
}
